import React from "react";
import { X } from "lucide-react";
import { getMarketWindowForNow } from "../utils/marketStatus";

function formatMarketTime(value) {
  if (!value) return "";
  const raw = String(value).trim();
  if (/am|pm/i.test(raw)) return raw.toLowerCase();
  const match = raw.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return raw;
  let hour = Number(match[1]);
  const minute = match[2];
  const meridiem = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${meridiem}`;
}

function marketInitial(name) {
  return String(name || "M").trim().charAt(0).toUpperCase() || "M";
}

function MarketSheet({ open, markets, selectedId, onSelect, onClose, title = "Select Market" }) {
  if (!open) return null;

  return (
    <div style={overlay}>
      <button type="button" style={scrim} onClick={onClose} aria-label="Close market selector" />
      <section style={sheet}>
        <div style={handle} />
        <div style={sheetHeader}>
          <h2 style={sheetTitle}>{title}</h2>
          <button type="button" style={closeButton} onClick={onClose} aria-label="Close">
            <X size={26} />
          </button>
        </div>
        <div style={list}>
          {(markets || []).map((market) => {
            const active = String(market.id) === String(selectedId);
            const marketWindow = getMarketWindowForNow(market);
            const openTime = formatMarketTime(marketWindow.open_time || market.open_time || market.open || market.start_time);
            const closeTime = formatMarketTime(marketWindow.close_time || market.close_time || market.close || market.end_time);
            return (
              <button
                type="button"
                key={market.id}
                style={{ ...row, ...(active ? activeRow : null) }}
                onClick={() => {
                  onSelect(market.id);
                  onClose();
                }}
              >
                <span style={{ ...avatar, ...(active ? activeAvatar : null) }}>{marketInitial(market.name)}</span>
                <span style={rowText}>
                  <strong style={rowName}>{market.name}</strong>
                  <span style={rowTime}>{openTime && closeTime ? `${openTime} - ${closeTime}` : openTime || closeTime}</span>
                </span>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default MarketSheet;

const overlay = {
  position: "fixed",
  inset: 0,
  zIndex: 1000,
};

const scrim = {
  position: "absolute",
  inset: 0,
  border: 0,
  background: "rgba(15, 23, 42, 0.62)",
  cursor: "pointer",
};

const sheet = {
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  maxHeight: "70vh",
  background: "#fff",
  borderRadius: "28px 28px 0 0",
  overflow: "hidden",
  boxShadow: "0 -18px 60px rgba(15, 23, 42, 0.2)",
};

const handle = {
  width: 80,
  height: 8,
  borderRadius: 999,
  background: "#d1d5db",
  margin: "16px auto 18px",
};

const sheetHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 22px 20px",
  borderBottom: "1px solid #e5e7eb",
};

const sheetTitle = {
  margin: 0,
  color: "#1f2937",
  fontSize: 18,
  fontWeight: 800,
  letterSpacing: 0,
};

const closeButton = {
  width: 40,
  height: 40,
  border: 0,
  background: "transparent",
  color: "#6b7280",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
};

const list = {
  maxHeight: "calc(70vh - 104px)",
  overflowY: "auto",
  padding: "0 14px 18px",
};

const row = {
  width: "100%",
  minHeight: 92,
  border: 0,
  borderRadius: 16,
  background: "#f8fafc",
  marginTop: 12,
  padding: "14px 18px",
  display: "flex",
  alignItems: "center",
  gap: 14,
  textAlign: "left",
  cursor: "pointer",
};

const activeRow = {
  background: "#dcfce7",
  border: "1px solid #86efac",
};

const avatar = {
  width: 56,
  height: 56,
  borderRadius: "50%",
  background: "#dcfce7",
  color: "#16a34a",
  display: "grid",
  placeItems: "center",
  fontSize: 22,
  fontWeight: 800,
  flexShrink: 0,
};

const activeAvatar = {
  background: "#16a34a",
  color: "#fff",
};

const rowText = {
  display: "grid",
  gap: 4,
  minWidth: 0,
};

const rowName = {
  color: "#1f2937",
  fontSize: 16,
  fontWeight: 800,
  lineHeight: 1.1,
};

const rowTime = {
  color: "#64748b",
  fontSize: 12,
  fontWeight: 500,
};
